<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-3">
        <search-info-packages @listen-search="listenSearchEvent" />
      </div>
      <div class="col-9">
        <div class="row">
          <div class="col">
            <h5 class="title">Report: Information Packages Ingested</h5>
          </div>
          <div class="col">
            <button @click="download_csv" class="btn btn-download btn-primary" :disabled="TypesenseCSVStore.loading">
              Download CSV
            </button>
          </div>
        </div>
        <div>
          <vue-good-table
            class="vue-table"
            ref="table"
            mode="remote"
            @page-change="onPageChange"
            @sort-change="onSortChange"
            @column-filter="onColumnFilter"
            @per-page-change="onPerPageChange"
            :isLoading.sync="isLoading"
            :pagination-options="paginationOptions"
            :totalRows="typesenseStore.totalRecords"
            :rows="typesenseStore.packageList"
            :columns="columns"
          >
            <template #table-actions-bottom>
              <pagination-records
                :pages="serverParams.page"
                :per-page="serverParams.per_page"
                :total="typesenseStore.totalRecords"
              />
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import PaginationRecords from "@/components/Pagination/PaginationRecords.vue";
import SearchInfoPackages from "@/components/Report2/SearchInfoPackages.vue";
import { ExportCsv } from "@/library/ExportCsv";
import { useTypesenseStore } from "@/stores/typesense";
import { useTypesenseCSVStore } from "@/stores/typesense_csv";
import { useAsyncState } from "@vueuse/core";
import { useAuditStore } from "@/stores/audit";
import moment from "moment";
import { ref, watch } from "vue";

const isLoading = ref(false);
const typesenseStore = useTypesenseStore();
const TypesenseCSVStore = useTypesenseCSVStore();
const table = ref();
const type = ref("secure-zone-packages");
const audit = useAuditStore();

const paginationOptions = ref({
  enabled: true,
  mode: "pages",
  position: "bottom",
  perPage: 20,
  perPageDropdown: [10, 20, 30],
  dropdownAllowAll: false,
});

const serverParams = ref({
  filter_by: "",
  sort_by: "",
  q: "*",
  query_by: "transfer_batch,transfer_agency",
  page: 1,
  per_page: paginationOptions.value.perPageDropdown[1],
});

const updateParams = (newProps: any) => {
  serverParams.value = Object.assign({}, serverParams.value, newProps);
};

const onPageChange = (params) => {
  updateParams({ page: params.currentPage });
  execute();
};
const onPerPageChange = (params) => {
  updateParams({ per_page: params.currentPerPage, page: 1 });
  execute();
};

const onSortChange = (params) => {
  if (params[0].type === "none") {
    updateParams({
      sort_by: "",
    });
  } else {
    updateParams({
      sort_by: params[0].field + ":" + params[0].type,
    });
  }
  execute();
};

const onColumnFilter = (params) => {
  table.value.reset();
  updateParams({ sort: params.sort, page: 1 });
  execute();
};

const listenSearchEvent = (inputParams) => {
  let searchData: string = "";
  for (const [key, value] of Object.entries(inputParams)) {
    if (!key.includes("transfer_batch")) {
      if (value) searchData += `${key}:${value}&&`;
    } else {
      serverParams.value.q = value as string;
    }
  }
  serverParams.value.filter_by = searchData.slice(0, -2);

  onColumnFilter(serverParams);
};

watch(
  () => typesenseStore.loading,
  (updateLoading) => (isLoading.value = updateLoading)
);

const formatFn = (value) => {
  return moment.unix(value).format("DD MMM yyyy HH:mm:ss");
};

const formatFn2 = (value) => {
  return moment.unix(value).format("DD MMM yyyy ");
};
const columns = [
  {
    label: "Transfer UUID",
    field: "transfer_uuid",
    width: "200px",
    sortable: false,
  },
  {
    label: "Transferring Agency",
    field: "transfer_agency",
    width: "220px",
    sortable: false,
  },
  {
    label: "Transfer Batch No",
    field: "transfer_batch",
    width: "200px",
  },
  {
    label: "Transfer Date",
    field: "transfer_date",
    formatFn: formatFn2,
    width: "120px",
  },
  {
    label: "Date Received",
    field: "created_at",
    formatFn: formatFn,
    width: "120px",
  },
  {
    label: "Ingestion Date",
    field: "date_of_ingestion",
    formatFn: formatFn,
    width: "120px",
  },
  {
    label: "Representation",
    field: "type",
    formatFn: function (value) {
      if (value == "DIP") return "Access";
      else if (value == "AIP") return "Master";
    },
    width: "150px",
    sortable: false,
  },
  {
    label: "Security Grading",
    field: "security_grading",
    width: "140px",
    sortable: false,
  },
  {
    label: "Sensitivity Classification",
    field: "sensitivity_classification",
    width: "140px",
    sortable: false,
  },
  {
    label: "No. of Computer Files",
    field: "files_count",
    width: "160px",
  },
];

const download_csv = () => {
  var x = typesenseStore.totalRecords / 250;
  var times = Math.ceil(x);

  var report_type = "InfoPackages";
  audit.auditLog("Report: Information Packages Ingested");

  TypesenseCSVStore.fetchTypesense(
    type.value,
    serverParams.value,
    times,
    columns,
    report_type
  );
  // ExportCsv.exportFile("Report2.csv", TypesenseCSVStore.csvList, columns);
};

const { execute, error } = useAsyncState(() => {
  return typesenseStore.fetchTypesense(type.value, serverParams.value);
}, null);
</script>

<style scoped>
.title {
  margin: 20px;
  margin-left: 0px;
  margin-bottom: 0px;
  padding: 4px;
}
.btn-download {
  width: 200px;
  margin-top: 16px;
  margin-bottom: 8px;
  float: right;
}
</style>
